/*
*  -insert desc here-
*
* Copyright (C) 2018, 2019 Sterilis Solutions, LLC, all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import {Button, Header, Modal, TransitionablePortal} from "semantic-ui-react";
import AuthService from "../../../AuthService";
import SimpleLoader from "../../../SimpleLoader";
import * as Sentry from "@sentry/browser";
const Auth = new AuthService();


class UnretireCustomerModal extends React.Component{
  state = {
    modalLoading : false,
    allowModalToBeClosed: true,
  };

  unretireCustomer = () => {
    const {
      customer
    } = this.props;
    this.setState({
      modalLoading : true,
      allowModalToBeClosed: false,
    });
    Auth.fetch(`/api/customer/${customer['id']}/`, {
      method : 'DELETE',
    }).then(() => {
     this.setState({
       modalLoading : false,
       allowModalToBeClosed: true,
     }, () => {
       this.props.preparePage();
       this.props.triggerUnretireCustomerModal(null);
       this.props.notifySuccess('Reactivate', 'customer', customer['customer_name'])
     });
    }).catch(err => {
      Sentry.captureException(err);
      this.setState({
         modalLoading : false,
        allowModalToBeClosed: true,
       }, () => {
        this.props.triggerUnretireCustomerModal();
        this.props.notifyFailure()
       });
    });
  };
  render() {
    const {
      t,
      customer
    } = this.props;
    const {
      modalLoading
    } = this.state;

    const inlineStyle = {
      modal : {
        // marginTop: topMargin,
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      textArea : {
        marginTop : '50px',
        width: '400px'
      }
    };
    return (
      <TransitionablePortal
          open={this.props.unretireCustomerModal}
          onOpen={() => setTimeout(() => document.body.classList.add('modal-fade-in'), 0)}
          transition={{ animation: 'scale', duration: 500 }}
      >
        <Modal
          style={inlineStyle.modal}
          open={true}
          closeOnDimmerClick={this.state.allowModalToBeClosed}
          closeIcon={<Button className='close-modal-btn grey-btn'>{t('Close')}</Button>}
          size='small'
          onClose={(event) => {
              document.body.classList.remove('modal-fade-in');
              this.props.triggerUnretireCustomerModal(null)
          }}
        >
          <Header>
            <h2 className='light-green'>{t('Reactivate Customer') }</h2>
          </Header>
          <Modal.Content>
            {modalLoading ? (
              <SimpleLoader/>
            ) : null}
           <div className='short-modal-text center-text'>
             <p>Reactivating the customer will allow facilities to be created underneath it.</p>
             <p>Archived facilities underneath <strong>{customer['customer_name']}</strong> will need to be manually reactivated.</p>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className='green-btn'
                    value="Submit"
                    type="submit"
                    id='unretireFacility'
                    onClick={this.unretireCustomer}
                    >{t('Reactivate Customer')}</Button>
          </Modal.Actions>
        </Modal>
      </TransitionablePortal>
    )
  }
}

export default translate('translations')(UnretireCustomerModal);
